const DemoSignupBanner = () => {
  return (
    <div className="sticky top-0 z-50 flex w-full flex-wrap items-center justify-between gap-2 bg-gradient-to-r from-ctadarkgreen to-emerald-600 px-4 py-2 text-white shadow-md">
      <p className="text-sm font-medium">
        You're viewing a demo of the TACH platform
      </p>
      <button
        onClick={() =>
          (window.location.href = 'https://tachusa.com/select-role')
        }
        className="shrink-0 rounded-full bg-white px-4 py-1 text-sm font-semibold text-ctadarkgreen transition-colors hover:bg-gray-100"
      >
        Sign Up Free
      </button>
    </div>
  );
};

export default DemoSignupBanner;
